import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://api.itosoba.ru/api/stocks';

function AdminStock() {
  const [stocks, setStocks] = useState([]);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchStocks();
  }, []);

  const fetchStocks = async () => {
    try {
      const res = await axios.get(API_URL);
      setStocks(res.data);
    } catch (err) {
      console.error('Ошибка при получении акций:', err);
      setError('Не удалось загрузить акции.');
    }
  };

  const handleAdd = async () => {
    if (!name || !description) {
      alert('Заполните все поля');
      return;
    }
    setLoading(true);
    try {
      await axios.post(API_URL, { name, description });
      setName('');
      setDescription('');
      fetchStocks();
    } catch (err) {
      console.error('Ошибка при добавлении акции:', err);
      alert('Не удалось добавить акцию.');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (id) => {
    if (!name || !description) {
      alert('Заполните все поля');
      return;
    }
    setLoading(true);
    try {
      await axios.put(`${API_URL}/${id}`, { name, description });
      setName('');
      setDescription('');
      setEditId(null);
      fetchStocks();
    } catch (err) {
      console.error('Ошибка при обновлении акции:', err);
      alert('Не удалось обновить акцию.');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setName(item.name || '');
    setDescription(item.description || '');
    setEditId(item.id);
  };

  const handleCancelEdit = () => {
    setName('');
    setDescription('');
    setEditId(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить эту акцию?')) return;
    try {
      await axios.delete(`${API_URL}/${id}`);
      fetchStocks();
    } catch (err) {
      console.error('Ошибка при удалении:', err);
      alert('Не удалось удалить акцию.');
    }
  };

  return (
    <div className="admin-container">
      <h2>Админка акций</h2>
      {error && <p className="error-message">{error}</p>}
      <div>
        <div className="form-group">
          <textarea style={{ width: '400px' }}
            placeholder="Название акции"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <textarea style={{ height: '500px', width: '400px' }}
            placeholder="Описание"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className="buttons">
          {editId ? (
            <>
              <button onClick={() => handleUpdate(editId)} disabled={loading}>
                {loading ? 'Обновление...' : 'Обновить'}
              </button>
              <button onClick={handleCancelEdit} disabled={loading}>
                Отмена
              </button>
            </>
          ) : (
            <button onClick={handleAdd} disabled={loading}>
              {loading ? 'Добавление...' : 'Добавить'}
            </button>
          )}
        </div>
      </div>

      <ul className="stocks-list">
        {stocks.map((item) => (
          <li key={item.id} className="stock-item">
            <h3>{item.name}</h3>
            <p>{item.description}</p>
            <div className="stock-buttons">
              <button onClick={() => handleEdit(item)}>Редактировать</button>
              <button onClick={() => handleDelete(item.id)}>Удалить</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AdminStock;